<template>
  <div class="evento-container">
    <!-- ENCABEZADO -->
    <div class="encabezado-ubicacion">
      <div class="ornamento ornamento-left" />
      <div class="ubicacion-linea">
        <div
          ref="lineaDecorativa"
          class="linea-decorativa"
        />
      </div>
    </div>

    <!-- RECEPCIÓN -->
    <div class="evento-card">
      <div class="icono-evento">
        <img
          src="@/assets/celebracionpng.png"
          alt="Ícono recepción"
        >
      </div>
      <p class="evento-tipo">
        Recepción
      </p>
      <div
        ref="imgRecepcion"
        class="evento-imagen-wrapper"
      >
        <img
          src="@/assets/evento.jpg"
          class="imagen-fondo"
        >
        <img
          src="@/assets/marco.png"
          class="marco-decorativo"
        >
      </div>
      <div
        ref="infoRecepcion"
        class="evento-info"
      >
        <p class="evento-lugar">
         Loveland Venue 
        </p>
        <p class="evento-direccion">
          18905 SW 168th St <br> Miami, Florida.
        </p>
        <p class="hora">
          6:00 PM
        </p>
        <a
          href="https://maps.app.goo.gl/kEZFxwGX558Hbhdr9"
          class="btn-mapa"
          target="_blank"
        >¿Cómo llegar?</a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const infoRecepcion = ref(null)
    const lineaCentralRef = ref(null)
    const lineaDecorativa = ref(null)
    const imgRecepcion = ref(null)

    const animarElemento = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 60 },
        { opacity: 1, y: 0, duration: 1.5, ease: 'power2.out' }
      )
    }

    const animarLinea = (element) => {
      gsap.fromTo(
        element,
        { scaleY: 0 },
        { scaleY: 1, transformOrigin: 'top center', duration: 1.2, ease: 'power2.out' }
      )
    }

    onMounted(() => {
      nextTick(() => {
        const observar = (el, accion) => {
          if (!el.value) return

          const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                accion()
                obs.unobserve(entry.target)
              }
            })
          }, { threshold: 0.4 })

          observer.observe(el.value)
        }

        observar(imgRecepcion, () => animarElemento(imgRecepcion.value))
        observar(infoRecepcion, () => animarElemento(infoRecepcion.value))
        observar(lineaDecorativa, () => animarLinea(lineaDecorativa.value))
        observar(lineaCentralRef, () => animarLinea(lineaCentralRef.value))
      })
    })

    return {
      infoRecepcion,
      lineaCentralRef,
      lineaDecorativa,
      imgRecepcion
    }
  }
}
</script>


<style scoped>
.evento-container {
  background-image: 
    linear-gradient(to bottom, rgba(86, 5, 5, 0.925), rgba(80, 7, 7, 0.847)), 
    url('@/assets/frojo.avif');
  color: #fff;
  margin-top: -20px;
  margin-bottom: -20px;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
}

.encabezado-ubicacion {
  text-align: center;
  margin-bottom: 16px;
}

.linea-decorativa {
  width: 40px;
  height: 1px;
  background-color: #e8e2e2;
  margin: 8px auto;
  transform: scaleX(0);
}

.evento-card {
  max-width: 400px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0px 0;
  border-radius: 12px;
  overflow: hidden;
}

.icono-evento {
  margin-top: 20px;
}

.icono-evento img {
  width: 100px;
  height: auto;
  display: inline-block;
  filter: drop-shadow(0 4px 6px rgba(177, 174, 174, 0.2));
}

.evento-imagen-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}

.imagen-fondo {
  width: 80%;
  max-height: 200px;
  object-fit: cover;
  display: block;
  border-radius: 2px;
  box-shadow: 0 10px 25px rgba(237, 233, 233, 0.016);
  position: relative;
  z-index: 1;
  margin: 0 auto;
}

.evento-imagen-wrapper::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 30%;
  background: linear-gradient(to top, rgba(255, 255, 255, 0), transparent);
  pointer-events: none;
  z-index: 0;
  border-radius: 2px;
}

.marco-decorativo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  mix-blend-mode: lighten;
  opacity: 0.8;
}

.evento-info {
  padding: 16px;
  color: #f9f6f6d9;
  opacity: 0;
}

.hora {
  font-family: 'fa';
  font-size: 15px;
  margin-bottom: 4px;
  color: #f0ebeb;
}

.evento-tipo {
  font-family: 'british', sans-serif;
  font-size: 34px;
  margin-bottom: 12px;
  color: #f9f9f9;
}

.evento-lugar {
  font-size: 16px  !important;
  font-weight: bold;
  margin-bottom: 5px;
}

.evento-direccion {
  font-family: 'padres';
  font-size: 12px;
  line-height: 1.4;
  font-weight: 800;
  color: #f4f4f4c6;
}

.btn-mapa {
  margin-top: 10px;
  background: #0a0a0ac5;
  color: rgb(154, 144, 11);
  font-size: 14px;
  padding: 6px 16px;
  text-decoration: none;
  font-family: 'padres';
  border-radius: 18px;
  font-weight: 800;
  display: inline-block;
  transition: background 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.btn-mapa:hover {
  background: #c49b9b;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);
}

.linea-central {
  width: 2px;
  height: 60px;
  margin: 20px auto;
  background-color: #ffffff;
  transform: scaleY(0);
}
</style>
